export const SET_HRES6NU_INDEX_DISP = 'SET_HRES6NU_INDEX_DISP'
export const GET_HRES6NU_INDEX_DISP = 'GET_HRES6NU_INDEX_DISP'
export const SET_HRES6NU_DETAIL_DISP = 'SET_HRES6NU_DETAIL_DISP'
export const GET_HRES6NU_DETAIL_DISP = 'GET_HRES6NU_DETAIL_DISP'
export const SET_HRES6NU_COLUMNS = 'SET_HRES6NU_COLUMNS'
export const GET_HRES6NU_COLUMNS = 'GET_HRES6NU_COLUMNS'
export const SET_HRES6NU_LABELS = 'SET_HRES6NU_LABELS'
export const GET_HRES6NU_LABELS = 'GET_HRES6NU_LABELS'
export const RECEIVED_HRES6NU_COLUMNS_LABELS = 'RECEIVED_HRES6NU_COLUMNS_LABELS'
export const SET_HRES6NU_INDEX = 'SET_HRES6NU_INDEX'
export const GET_HRES6NU_INDEX = 'GET_HRES6NU_INDEX'
export const RECEIVED_HRES6NU_INDEX = 'RECEIVED_HRES6NU_INDEX'
export const SET_HRES6NU_INDEX_SELECTED = 'SET_HRES6NU_INDEX_SELECTED'
export const GET_HRES6NU_INDEX_SELECTED = 'GET_HRES6NU_INDEX_SELECTED'
export const SET_HRES6NU_DETAIL = 'SET_HRES6NU_DETAIL'
export const GET_HRES6NU_DETAIL = 'GET_HRES6NU_DETAIL'
export const RECEIVED_HRES6NU_DETAIL = 'RECEIVED_HRES6NU_DETAIL'
export const TOGGLE_HRES6NU_PAGE = 'TOGGLE_HRES6NU_PAGE'
export const POST_HRES6NU_SEND_APPROVE = 'POST_HRES6NU_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres6nu/mutation-types.js